<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Search SMS Logs</strong>
          </div>
          <b-form @submit.prevent="searchLogs()">
            <b-form-group
              label-class="font-weight-bold">
              <div style="display: flex; flex-wrap: wrap;">
                <!-- <label class="col-sm-1 col-form-label" style="text-align: center">From</label> -->
                <div>
                  <v-date-picker
                    mode='single'
                    v-model='startDateBegin'
                    :input-props='{class:"form-control", readonly: true }'>
                    <b-form-group
                      slot-scope='{ inputValue, updateValue }'>
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-input-group-text>From</b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input
                          type="text"
                          data-lpignore=true
                          placeholder='-10 days' 
                          autocomplete="off"
                          :value='inputValue'
                          @input.native='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                          @change.native='updateValue($event.target.value, { formatInput: true, hidePopover: false })'></b-form-input>
                        <!-- Attach Right button -->
                        <b-input-group-append>
                          <b-button variant="primary" style="z-index: auto" :disabled="!startDateBegin" @click='startDateBegin = null'>Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </v-date-picker>
                </div>
                <div class="visible-md" style="width: 20px"></div>
                <!-- <label class="col-sm-1 col-form-label"  style="text-align: center">To</label> -->
                <div>
                  <v-date-picker
                    mode='single'
                    v-model='startDateEnd'
                    :input-props='{class:"form-control"}'
                    :min-date='startDateBegin'>
                    <b-form-group
                      slot-scope='{ inputValue, updateValue }'>
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-input-group-text>To</b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input
                          type="text"
                          data-lpignore=true
                          placeholder='Today' 
                          autocomplete="off"
                          :value='inputValue'
                          @input.native='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                          @change.native='updateValue($event.target.value, { formatInput: true, hidePopover: false })'></b-form-input>
                        <!-- Attach Right button -->
                        <b-input-group-append>
                          <b-button variant="primary" style="z-index: auto" :disabled="!startDateEnd" @click='startDateEnd = null'>Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </v-date-picker>
                </div>
              </div>
            </b-form-group>
            <div slot="footer">
              <transition name="fade">
                <b-alert show variant="danger" style="width: 100%;" v-if="error">{{error.message}}</b-alert>
              </transition>
              <b-button type="submit" size="sm" variant="primary" class="btn btn-primary ladda-button" id="search-button" data-style="expand-right"><i class="fa fa-search"></i> Search</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    
    <transition name="fade">
      <b-row v-if="logs.length > 0">
        <b-col md="12">
          <b-card>
            <div slot="header">
              <i class="fa fa-file-text-o"></i>
              <strong> SMS Logs</strong>
            </div>
            <v-client-table name="logsDatatable" :columns="columns" :data="logs" :options="options" :theme="theme" id="dataTable" v-if="logs.length > 0">
            </v-client-table>
          </b-card>
        </b-col>
      </b-row>
    </transition>
  </div>
</template>

<script>
import api from "../api";
import config from '../config'
import store from "../store";
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";
import * as Ladda from "ladda";

import VCalendar from "v-calendar";
import "v-calendar/lib/v-calendar.min.css";

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";

import moment from 'moment'

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

miniToastr.setIcon("success", "i", { class: "fa fa-check-circle-o" });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

Vue.use(VueNotifications, options);

Vue.use(ClientTable);

Vue.use(VCalendar, {
  firstDayOfWeek: 2,
  formats: {
    title: 'MMMM YYYY',
    weekdays: 'W',
    navMonths: 'MMM',
    input: ['DD/MM/YYYY'],
    dayPopover: 'L',
    data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD']
  }
});

function compareDate(a, b, key, ascending) {
  let dateA = moment(a[key], "DD-MM-YYYY HH:mm:ss").unix()
  let dateB = moment(b[key], "DD-MM-YYYY HH:mm:ss").unix()

  if (ascending) return dateA >= dateB ? 1 : -1
  return dateA <= dateB ? 1 : -1
}

export default {
  name: "smsLogs",
  components: {
    ClientTable,
    Event
  },
  data() {
    return {
      searchButton: null,
      error: null,
      columns: ["id","date","phone","isSent","msg"],
      options: {
        headings: {
          id: "ID",
          date: "Date",
          phone: "Phone",
          isSent: "Sent",
          msg: "Content",
        },
        templates: {
          isSent: function(h, row, index) {
            if (row.isSent) return <i class="fa fa-check" />;
            return <i class="fa fa-times" />;
          }
        },
        sortable: ["id","date","phone","isSent"],
        customSorting: {
          date: function(ascending) {
            return function(a, b) {
              return compareDate(a, b, "date", ascending)
            }
          }
        },
        filterable: ["id","date","phone","isSent","msg"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: "fixed"
        }
      },
      useVuex: true,
      theme: "bootstrap4",
      template: "default",
      startDateBegin: null,
      startDateEnd: null,
      logs: []
    };
  },
  mounted: function() {
    this.searchButton = Ladda.create(document.querySelector("#search-button"));
  },
  methods: {
    searchLogs: function() {
      this.error = null
      this.searchButton.start();
      api.request("get", config.serverURI + 'smslogs', null, {
          beginDate: this.formatDate(this.startDateBegin),
          endDate: this.formatDate(this.startDateEnd)
        })
        .then(response => {
          let logs = response.data
          this.logs = logs.reverse() // put the most recent first
          console.log(logs)
          console.log(logs)
          this.searchButton.stop();
          if (response.data.length === 0) {
            this.error = {
              message: "No logs match the search parameters!"
            };
          }
        })
        .catch(error => {
          this.logs = []
          this.searchButton.stop();
          if (error.response) {
            this.error = {
              message: error.response.data
            };
          } else {
            this.error = {
              message: "Server error!"
            };
          }
        });
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    formatDate(date) {
      if (date) return `${moment(date).format("DD-MM-YYYY HH:mm:ss")}`
      else return null
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active {
  transition: all 0.8s ease;
}
.fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter, .fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  /* transform: translateX(10px); */
  opacity: 0;
}
</style>

<style lang="scss">
#dataTable {
  width: 95%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.25rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>